import { CHAT_MEDIA_RETURN_TYPE } from '../constants/chatRequests.constants';

export const CHAT_MEDIA_GALLERY_TYPE = {
	IMAGE: 'image',
	VIDEO: 'video',
};

export const getMessageGalleryMedia = (msg) => {
	const isImage = msg?.response_format === CHAT_MEDIA_RETURN_TYPE.IMAGE;
	const isVideo =
		msg?.response_format === CHAT_MEDIA_RETURN_TYPE.VIDEO || Boolean(msg?.video);

	if (isImage && msg.image?._id) {
		return {
			url: msg.image._id,
			caption: msg.content,
			type: CHAT_MEDIA_GALLERY_TYPE.IMAGE,
		};
	}

	if (isVideo) {
		const mediaId = msg.video?._id ?? msg.image?._id;

		if (mediaId) {
			return {
				url: mediaId,
				caption: msg.content,
				type: CHAT_MEDIA_GALLERY_TYPE.VIDEO,
			};
		}
	}

	return null;
};

export const getConversationMediaFromMessages = (messages) => {
	return messages.map(getMessageGalleryMedia).filter(Boolean);
};
